import {CrudApiService} from "@/services/api/api.base.js";

export class OptionsApiService extends CrudApiService {
  constructor(resource, notifier, callback) {
    super(resource, notifier, callback);
  }

  async updOptions(params) {
    const data = await super.post("set", params);
    return data;
  }

  async getOptions() {
    const data = await super.get("get");
    return data;
  }
}